export default "__VITE_ASSET__Dll8GocT__"